import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ASC, IDLE, PENDING, VIEW } from "const"
import { SilSafetyFunction } from "server/models"
import {
    StateType,
    hasProjectAccess,
} from "client/utils"
import { sort } from "client/store/utils"
import {
    PRM_SIL_RESULTS,
    PRM_SIL_RESULTS_PDF,
    StoreType,
    LoadAllSilSafetyFunctions,
    LoadSilResultSafetyFunctionById,
    LoadUpdatedSilProjectDevices,
    setSilResultSafetyFunctionList,
    setSilResultCalculatedSafetyFunction,
    setSilResultUpdatedDevices,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    Button,
    SpinnerIcon,

    LangReportWrapper,
    LangReportSwitcher,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import Overview from "./overview"
import Report from "./report"
import ExportToPDF from "./exportToPDF"

const Results = () => {
    const safetyFunctions = useSelector((state: StoreType) => state.silResultSafetyFunction.safetyFunctionList)
    const reloadList = useSelector((state: StoreType) => state.silResultSafetyFunction.reloadList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)

    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const userSettings = useSelector((state: StoreType) => state.system.userSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const langReport = useSelector((state: StoreType) => state.system.langReport)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [reportIsLoading, setReportIsLoading] = useState(false)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        Promise.all([
            LoadAllSilSafetyFunctions(project.id).then((res1) => {
                const safetyFunctionList = (Object.values(res1) as SilSafetyFunction[]).sort((a, b) => sort(a, b, "name", ASC))
                dispatch(setSilResultSafetyFunctionList(safetyFunctionList))

                const promiseArray: Promise<any>[] = []
                safetyFunctionList.forEach((safetyFunction) => {
                    promiseArray.push(
                        LoadSilResultSafetyFunctionById(safetyFunction.id, project.id).then((res2) => {
                            if (res2 && res2.id) dispatch(setSilResultCalculatedSafetyFunction(res2))
                        }),
                    )
                })

                return Promise.all(promiseArray)
            }),
            LoadUpdatedSilProjectDevices(project.id).then((deviceCount) => {
                dispatch(setSilResultUpdatedDevices(deviceCount))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadList])

    const viewAccess = hasProjectAccess(PRM_SIL_RESULTS, VIEW)
    const viewPdfAccess = hasProjectAccess(PRM_SIL_RESULTS_PDF, VIEW)

    if (!viewAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.silCalculationReport}</PageTitle>
                {
                    safetyFunctions.length > 0 && viewPdfAccess
                    && (
                        <LangReportWrapper>
                            <LangReportSwitcher />
                            <Button
                                variant="success"
                                disabled={loadState === PENDING}
                                onClick={() => ExportToPDF(
                                    project,
                                    moduleList,
                                    accountSettings,
                                    projectSettings,
                                    userSettings,
                                    userData,
                                    langReport,
                                    setReportIsLoading,
                                )}
                            >
                                {reportIsLoading ? <SpinnerIcon /> : lang.export}
                            </Button>
                        </LangReportWrapper>
                    )
                }

            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Overview />
                {
                    safetyFunctions.length > 0
                    && <Report />
                }
            </PageContent>
        </Container>
    )
}
export default Results
